var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-page d-flex",class:_vm.customClass},[_c('div',{staticClass:"max-width"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }